/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  SettleRealizedPnlRecordOptions,
  SettleRealizedPnlRecordResponses,
} from '../types/SettleRealizedPnlRecord'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @summary Mark a realized P&L settlement as settled
 * {@link /v1/realized_pnl_settlements/:settlement_id}
 */
export function settleRealizedPnlRecord<ThrowOnError extends boolean = true>(
  options: Options<SettleRealizedPnlRecordOptions, ThrowOnError>,
): Unwrappable<RequestResult<SettleRealizedPnlRecordResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'PUT',
      url: '/v1/realized_pnl_settlements/{settlement_id}',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<SettleRealizedPnlRecordResponses, ThrowOnError>>,
  )
}
